function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 18 18"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M8.167 14h1.666v-1.667H8.167V14zM9 .667A8.336 8.336 0 00.667 9c0 4.6 3.733 8.333 8.333 8.333S17.333 13.6 17.333 9 13.6.667 9 .667zm0 15A6.676 6.676 0 012.333 9 6.676 6.676 0 019 2.333 6.676 6.676 0 0115.667 9 6.676 6.676 0 019 15.666zM9 4a3.332 3.332 0 00-3.333 3.333h1.666c0-.917.75-1.667 1.667-1.667s1.667.75 1.667 1.667c0 1.667-2.5 1.458-2.5 4.167h1.666c0-1.875 2.5-2.084 2.5-4.167A3.332 3.332 0 009 4z"
})));